import { render, staticRenderFns } from "./UserAvatarCard.vue?vue&type=template&id=95808ad4&scoped=true"
import script from "./UserAvatarCard.vue?vue&type=script&lang=js"
export * from "./UserAvatarCard.vue?vue&type=script&lang=js"
import style0 from "./UserAvatarCard.vue?vue&type=style&index=0&id=95808ad4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95808ad4",
  null
  
)

export default component.exports